import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { SiNoEnum } from "@app/shared/enum/si-no-enum";
import { TipoFormEnum } from "@app/shared/enum/tipo-form.enum";
import { AnagCampiSpecificiService } from "@app/shared/services/anag-campi-specifici.service";
import { CampoSpecificoFascicolazioneVO } from "@app/shared/vo/campo-specifico-fascicolazioneVO";
import { ValoreCampoVO } from "@app/shared/vo/valori-campoVO";
import { TypeaheadMatch } from "ngx-bootstrap";

@Component({
  selector: "app-valore-campo-specifico-manuale",
  templateUrl: "./valore-campo-specifico-manuale.component.html",
})
export class ValoreCampoSpecificoManualeComponent implements OnInit {
  @Input()
  campo: CampoSpecificoFascicolazioneVO;
  @Input()
  ultimo: boolean;
  @Input()
  valore: ValoreCampoVO;
  @Input()
  tipoForm: TipoFormEnum;
  @Output()
  emitAggiungiNuovo: EventEmitter<string> = new EventEmitter();
  @Output()
  emitValore: EventEmitter<string> = new EventEmitter();
  @Output()
  emitRimuovi: EventEmitter<string> = new EventEmitter();
  valoreDigitato: ValoreCampoVO ;
  digitazioneTerminata: boolean = false;
  public asyncSelected: string;
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;
  public valoreBool: boolean = false;
  listaValori: ValoreCampoVO[];
  output: String[];
  constructor(private anagCampiSpecificiService: AnagCampiSpecificiService) {}

  ngOnInit() {
    if (this.valore && this.valore.valore !== null) {
      this.valoreDigitato  = this.valore;
      this.digitazioneTerminata = true;
    } else {
      this.digitazioneTerminata = false;
    }
      this.anagCampiSpecificiService.getAnagCampoSpecifico(this.campo.idAnagrafica).subscribe(
      (res) => {
        this.listaValori = res.listaOutput;
      },
      (err) => {
        console.log("ValoreCampoSpecificoManualeComponent err", err);
      
      }
    );
  }

  aggiungiNuovoValore() {
    this.emitAggiungiNuovo.emit();
    if (this.tipoForm === TipoFormEnum.MODIFICA) {
      this.digitazioneTerminata = true;
    } else {
      this.digitazioneTerminata = false;
    }
  }

  rimuovi() {
    this.emitRimuovi.emit();
  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean): void {
    this.valoreBool = true;
    this.typeaheadNoResults = e;
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    console.log("typeaheadOnSelect", e);
    this.valoreDigitato = e.item;
    this.digitazioneTerminata = true;
    this.emitValore.emit(e.item.valore);
  }

  getDisabledPlus() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.ultimo) {
          return false;
        } else {
          return true;
        }
        
      case TipoFormEnum.CREAZIONE:
        if (this.digitazioneTerminata) {
          return false;
        } else {
          return true;
        }
    }
    return true;
  }

  getPlusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.campo.ripetibile  === SiNoEnum.SI && this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.campo.ripetibile  === SiNoEnum.SI  && this.valoreDigitato) {
          return true;
        }
    }
    return false;
  }

  getMinusVisible() {
    switch (this.tipoForm) {
      case TipoFormEnum.MODIFICA:
        if (this.valoreDigitato) {
          return true;
        }
        break;
      case TipoFormEnum.CREAZIONE:
        if (this.valoreDigitato) {
          return true;
        }
    }

    return false;
  }
}
